import { inject } from '@angular/core';
import { RedirectFunction, Router } from '@angular/router';

import { FOLDER_IDS } from '@shared/consts';

/** Redirects the stable email link before the guarded tenant route is activated. */
export const sharedFileRedirect: RedirectFunction = ({ params, queryParamMap }) => {
  const router = inject(Router);
  const tenantId = params['tenantId'];
  const fileId = Number(queryParamMap.get('e'));
  return Number.isSafeInteger(fileId) && fileId > 0
    ? router.createUrlTree(['/', tenantId, 'my-drive'], {
        queryParams: { fid: FOLDER_IDS.SHAREDWITHME, id: fileId },
      })
    : router.createUrlTree(['/', tenantId, '404']);
};
